import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AppState } from '@redux/store'
import {
  AnalyticsApplyPayload,
  AnalyticsEvent,
  AnalyticsRejectPayload,
  InsuranceAcceptEventData,
  InsuranceOpenEventData,
  InsuranceRejectEventData,
} from '@typesApp/Analytics'
import { createAnalyticsAcceptEventData, createAnalyticsRejectEventData } from '@utils/analyticsUtil'

export interface AnalyticsState {
  event?: InsuranceOpenEventData | InsuranceAcceptEventData | InsuranceRejectEventData
}

const initialState: AnalyticsState = {} as const

const REDUCER_PATH = 'analytics'

export const analyticsSlice = createSlice({
  name: REDUCER_PATH,
  initialState: initialState,
  reducers: {
    insuranceOpenEvent(state) {
      state.event = {
        type: 'open',
        id: 'Impression',
        Page_Section2: 'InsurancePanel',
      }
    },
    insuranceAcceptedEvent(state, action: PayloadAction<AnalyticsApplyPayload>) {
      state.event = createAnalyticsAcceptEventData(action.payload)
    },
    insuranceRejectedEvent(state, action: PayloadAction<AnalyticsRejectPayload>) {
      state.event = createAnalyticsRejectEventData(action.payload)
    },
    resetInsuranceEvent(state) {
      state.event = undefined
    },
    resetAnalyticsInitialState(state) {
      return initialState
    },
  },
})

export const {
  insuranceOpenEvent,
  insuranceAcceptedEvent,
  insuranceRejectedEvent,
  resetInsuranceEvent,
  resetAnalyticsInitialState,
} = analyticsSlice.actions

export const analyticsEventSelector = (state: AppState): AnalyticsEvent | undefined => state.analytics.event
